import { useIsDesktop } from 'Hooks';
import { DesktopUI } from './DesktopUI';
import { MobileUI } from './MobileUI';

export const B2CError = () => {
  const isDesktop = useIsDesktop();

  return isDesktop ? <DesktopUI /> : <MobileUI />;
};
